import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { permissions } from 'utils/constants';
var accessRoles = {
  OWNER: 'owner',
  EXPLORER: 'explorer',
  VIEWER: 'viewer',
  ADMIN: 'admin'
};
var permissionsByRole = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, accessRoles.OWNER, new Set([permissions.WRITE, permissions.READ_USER_ACCESS])), accessRoles.EXPLORER, new Set([permissions.WRITE, permissions.READ_USER_ACCESS])), accessRoles.VIEWER, new Set([])), accessRoles.ADMIN, new Set([permissions.WRITE, permissions.READ_USER_ACCESS]));
var getHasPermissions = function getHasPermissions(experimentId, permissionsToCheck) {
  var projectType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'experiment';
  return function (state) {
    // we don't have viewer role for secondary analysis yet
    if (projectType === 'secondaryAnalysis') {
      return true;
    }
    var role = experimentId ? state.experiments[experimentId].accessRole : state.experimentSettings.info.accessRole;
    return permissionsByRole[role].has(permissionsToCheck);
  };
};
export default createMemoizedSelector(getHasPermissions);
export { accessRoles };